import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function TestimonialsGrid({ items = TESTIMONIALS, heading = true }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10">
      {items.map((t, i) => (
        <Reveal key={i} delay={(i % 3) * 0.1}>
          <div className="bg-white h-full p-8 md:p-10 flex flex-col" data-testid={`testimonial-${i}`}>
            <span className="font-display text-6xl text-sand leading-none mb-4">&ldquo;</span>
            <p className="text-charcoal font-light leading-relaxed flex-1 text-[15px]">{t.quote}</p>
            <div className="mt-8 pt-6 border-t border-black/10">
              <div className="font-display font-bold text-lg">{t.name}</div>
              <div className="text-xs text-taupe mt-1 uppercase tracking-[0.15em]">{t.location} · {t.service}</div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
